// TODO implement AddPaymentInfo event
// TODO check if more values can be passed to product and cart pages

// https://business.twitter.com/en/help/campaign-measurement-and-analytics/conversion-tracking-for-websites.html

/**
 * Copyright 2024 SweetCode. All rights reserved.
 *
 * Load Twitter Ads event listeners
 * */

// Pixel load event listener
jQuery(document).on("pmw:load-pixels", () => {

	if (wpmDataLayer?.pixels?.twitter?.pixel_id && !wpmDataLayer?.pixels?.twitter?.loaded) {
		if (wpm.consent.canPixelBeFired("marketing", "Twitter")) wpm.loadTwitterPixel()
	}
})

// add-to-cart event
jQuery(document).on("pmw:add-to-cart", (event, product) => {

	try {
		if(wpm.canNotFireTwitterEvent()) return

		if (wpmDataLayer?.pixels?.twitter?.event_ids?.add_to_cart) {

			const data = {
				value   : product.quantity * product.price,
				currency: wpmDataLayer.shop.currency,
				contents: [{
					content_type : "product",
					content_id   : wpmDataLayer.products[product.id].dyn_r_ids[wpmDataLayer.pixels.twitter.dynamic_remarketing.id_type],
					content_name : product.name,
					content_price: product.price,
					num_items    : product.quantity,
					// content_group_id: null,
				}],
			}

			twq("event", wpmDataLayer.pixels.twitter.event_ids.add_to_cart, data)
			pmw.console.log("Twitter Pixel: add_to_cart event sent", data)
		} else {
			// Legacy event
			twq("track", "AddToCart")
			pmw.console.log("Twitter Pixel: add_to_cart event sent")
		}
	} catch (e) {
		console.error(e)
	}
})

// view product event
jQuery(document).on("pmw:view-item", (event, product = null) => {

	try {
		if(wpm.canNotFireTwitterEvent()) return

		let productData = {}

		if (product) {
			productData = {
				value   : product.quantity * product.price,
				currency: wpmDataLayer.shop.currency,
				contents: [{
					content_type : "product",
					content_id   : wpmDataLayer.products[product.id].dyn_r_ids[wpmDataLayer.pixels.twitter.dynamic_remarketing.id_type],
					content_name : product.name,
					content_price: product.price,
					num_items    : product.quantity,
					// content_group_id: null,
				}],
			}
		}

		if (wpmDataLayer?.pixels?.twitter?.event_ids?.view_content) {
			twq("event", wpmDataLayer.pixels.twitter.event_ids.view_content, productData)
			pmw.console.log("Twitter Pixel: view_content event sent", productData)
		} else {
			// Legacy event
			twq("track", "ViewContent")
			pmw.console.log("Twitter Pixel: view_content event sent")
		}

	} catch (e) {
		console.error(e)
	}
})

// // view category event
// jQuery(document).on('pmw:view-category', function () {
//
// 	if(wpm.canNotFireTwitterEvent return;
//
// 	// twq('track', 'AddToWishlist');
// });

// add-to-wishlist event
jQuery(document).on("pmw:add-to-wishlist", (event, product) => {

	try {
		if(wpm.canNotFireTwitterEvent()) return

		let productData = {}

		if (product) {
			productData = {
				value   : product.quantity * product.price,
				currency: wpmDataLayer.shop.currency,
				contents: [{
					content_type : "product",
					content_id   : wpmDataLayer.products[product.id].dyn_r_ids[wpmDataLayer.pixels.twitter.dynamic_remarketing.id_type],
					content_name : product.name,
					content_price: product.price,
					num_items    : product.quantity,
					// content_group_id: null,
				}],
			}
		}

		if (wpmDataLayer?.pixels?.twitter?.event_ids?.add_to_wishlist) {
			twq("event", wpmDataLayer.pixels.twitter.event_ids.add_to_wishlist, productData)
			pmw.console.log("Twitter Pixel: add_to_wishlist event sent", productData)
		} else {
			// Legacy event
			twq("track", "AddToWishlist")
			pmw.console.log("Twitter Pixel: add_to_wishlist event sent")
		}

	} catch (e) {
		console.error(e)
	}
})

// start checkout event
jQuery(document).on("pmw:begin-checkout", () => {

	try {
		if(wpm.canNotFireTwitterEvent()) return

		if (wpmDataLayer?.pixels?.twitter?.event_ids?.initiate_checkout) {
			twq("event", wpmDataLayer.pixels.twitter.event_ids.initiate_checkout, {})
			pmw.console.log("Twitter Pixel: initiate_checkout event sent", {})
		} else {
			// Legacy event
			twq("track", "InitiateCheckout")
			pmw.console.log("Twitter Pixel: initiate_checkout event sent")
		}

	} catch (e) {
		console.error(e)
	}
})

// add-payment-info event
jQuery(document).on("pmw:add-payment-info", () => {

	try {
		if(wpm.canNotFireTwitterEvent()) return

		if (wpmDataLayer?.pixels?.twitter?.event_ids?.add_payment_info) {
			twq("event", wpmDataLayer.pixels.twitter.event_ids.add_payment_info, {})
			pmw.console.log("Twitter Pixel: add_payment_info event sent", {})
		} else {
			// Legacy event
			twq("track", "AddPaymentInfo")
			pmw.console.log("Twitter Pixel: add_payment_info event sent")
		}

	} catch (e) {
		console.error(e)
	}
})

// View search event
jQuery(document).on("pmw:search", () => {

	try {
		if(wpm.canNotFireTwitterEvent()) return

		if (wpmDataLayer?.pixels?.twitter?.event_ids?.search) {

			const data = {
				search_string: wpm.getSearchTermFromUrl(),
			}

			twq("event", wpmDataLayer.pixels.twitter.event_ids.search, data)
			pmw.console.log("Twitter Pixel: search event sent", data)
		} else {
			// Legacy event
			twq("track", "Search")
			pmw.console.log("Twitter Pixel: search event sent")
		}

	} catch (e) {
		console.error(e)
	}
})


// view order received page event
// TODO find out under which circumstances to use different values in content_type
jQuery(document).on("pmw:view-order-received-page", () => {

	try {
		if(wpm.canNotFireTwitterEvent()) return

		if (wpmDataLayer?.pixels?.twitter?.event_ids?.purchase) {
			const data = {
				value        : wpmDataLayer.order.value.marketing,
				currency     : wpmDataLayer.order.currency,
				conversion_id: wpmDataLayer.order.id,
				contents     : wpm.twitterGetOrderContentIdsV2(),
			}
			twq("event", wpmDataLayer.pixels.twitter.event_ids.purchase, data)
			pmw.console.log("Twitter Pixel: purchase event sent", data)
		} else {
			// Legacy event
			const data = {
				order_id: wpmDataLayer.order.id,
				// content_type: 'product',
				value      : wpmDataLayer.order.value.marketing,
				currency   : wpmDataLayer.order.currency,
				num_items  : wpmDataLayer.order.quantity,
				content_ids: wpm.twitterGetOrderContentIdsV1(),
			}

			twq("track", "Purchase", data)
			pmw.console.log("Twitter Pixel: purchase event sent", data)
		}

	} catch (e) {
		console.error(e)
	}
})

